/* fr-CA locale */
export default {
  appTitle: 'Tableau d\'appel',
  localeName: 'Français',
  copyright: 'Tous droits réservés',
  languages: {
    'en-US': 'Anglais (US)',
    'en-AU': 'Anglais (AU)',
    'en-GB': 'Anglais (GB)',
    'fr-CA': 'Francais (CA)'
  },
  // login page
  login: {
    title: 'Connecter Panneau d\'Appel',
    note: 'Utilisez votre nom d\'utilisateur et votre mot de passe',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    btn: 'Connecter',
    wait: 'Authentification. Veuillez patienter...',
    error: {
      required: 'Requis.',
      password: 'Mot de passe invalide.',
      username: 'Nom d\'utilisateur invalide.',
      login: 'Échec de connexion. Courriel ou mot de passe invalide.',
      oauth2: 'Échec de l\'authentification avec jeton oauth2',
      session: 'La session est invalide. Veuillez vous authentifier.'
    }
  },
  // toolbar
  tb: {
    signout: 'Déconnecter',
    currentUser: {
      quick_access: 'Accès rapide',
      language: 'Langue',
      theme: 'Thème'
    },
    filter: {
      placeholder: 'Filtrer les utilisateurs',
      hintResult: '{num} utilisateur{plur} trouvé{plur}'
    },
    sipua: {
      sipUri: 'SIP URI',
      sipProxy: 'SIP Proxy',
      online: 'Téléphone en ligne',
      offline: 'Téléphone hors-ligne'
    },
    sort: {
      title: 'Paramètres de tri',
      byexten: 'Par poste',
      byname: 'Par nom',
      dirTitle: 'Ordre:',
      acs: 'Ascendant',
      desc: 'Descendant',
      btnCancel: 'Annuler',
      btnSort: 'Trier'
    },
    cview: {
      label: 'Compacter',
      on: 'Activé',
      off: 'Désactivé'
    },
    embedded: {
      btn: {
        close: 'Fermer'
      }
    }
  },
  rmqc: {
    online: 'Agent de messages est en ligne',
    offline: 'Agent de messages est déconnecté',
    error: {
      api: 'La connexion à l\'API a échoué',
      init: 'L\'initialisation du client RabbitMQ a échoué.',
      connLost: 'La connexion RabbitMQ a été perdue.'
    }
  },
  // buddy card
  buddy: {
    searchPlaceholder: 'Chercher un utilisateur par poste, nom ou département',
    draggable: 'Déplaçable',
    sort: {
      title: 'Trier',
      custom: 'Personnalisé',
      byExtension: 'Par Poste',
      byName: 'Par Nom',
      byStatus: 'Par Statut'
    },
    tooltip: {
      vm: 'Les messages dans la boîte vocale.',
      listen: 'Écouter l\'appel en cours.',
      sipcall: 'Appeler l\'utilisateur',
      unwatch: 'Enlever la surveillance.',
      watch: 'Commencer la surveillance.',
      unpark: 'Récupérer un appel parqué',
      dndOver: 'Déposer pour transférer l\'appel {call} à {to}',
      startChat: 'Commencer un chat avec cet utilisateur'
    },
    calltime: {
      from: 'De',
      to: 'À'
    },
    bargein: {
      title: 'Intervention téléphonique',
      cancel: 'Annuler',
      start: 'Démarer',
      monitor: 'Surveiller l\'appel',
      fullBarge: 'Intervention complète',
      whisper: 'Chuchoté sur {0}'
    },
    status: {
      online: 'L\'utilisateur est en ligne.',
      offline: 'L\'utilisateur est déconnecté.',
      calling: 'Appel en cours...',
      busy: 'L\'utilisateur est occupé.',
      away: 'L\'utilisateur est absent.',
      oncall: 'L\'utilisateur est au téléphone.',
      ringing: 'Le téléphone sonne',
      onlunch: 'L\'utilisateur est en pause déjeuner.',
      unknown: 'Statut inconnu.',
      sms: 'L\'utilisateur est un SMS.'
    },
    prefs: {
      dndOn: 'Ne pas Déranger activé',
      dndOff: 'Ne pas Déranger désactivé',
      smcOn: 'Affichage des appels manqués activé',
      smcOff: 'Affichage des appels manqués désactivé',
      fwdOn: 'Renvoi d\'appel activé',
      fwdOff: 'Renvoi d\'appel désactivé',
      fmeOn: 'Suivez-moi activé',
      fmeOff: 'Suivez-moi désactivé'
    },
    card: {
      dept: 'Departement',
      dropZone: 'Déposez ici'
    },
    jambotron: {
      title: 'Panneau d\'appel',
      note: 'Les usagers à regarder peuvent être configuré en ajoutant un départment au compte utilisateur'
    }
  },
  // loading dialog
  loading: {
    statusDefault: 'Veuillez patienter...',
    dataInit: 'Chargement des données...'
  },
  // Users left navigation panel
  users: {
    menuTitle: 'Utilisateurs',
    displayOptions: 'Options d\'affichage'
  },
  userPictureProfiles: {
    title: 'Image(s) de profil',
    emptyPlaceholder: 'Vos photos de profil seront ici. Vous pourrez voir votre photo téléversée et votre photo Gmail si vous vous connectez avec un compte Google.',
    reloadRequired: 'Rafraichir la page pour voir les changements',
    pictureTypes: {
      gmail: 'Gmail',
      uploaded: 'Téléverser'
    },
    fileField: {
      label: 'Téléverser une nouvelle image de profil',
      placeholder: 'Choisir une image'
    },
    crop: {
      title: 'Outil de recadrage'
    },
    errors: {
      unvalidateImage: 'Veuillez sélectionner un fichier image',
      unsupportedFileReader: 'Désolé, l\'API FileReader n\'est pas prise en charge'
    },
    btn: {
      cancel: 'Annuler',
      close: 'Fermer',
      crop: 'Recadrer',
      noCrop: 'Ne pas recadrer'
    }
  },
  chat: {
    menuTitle: 'Chat',
    navTitle: 'Chat',
    openMenu: 'Ouvrir le menu',
    as: 'En tant que',
    youu: 'vous',
    closed: 'Fermé',
    filterClosed: 'Filtrer les conversations fermée(s)',
    filterRead: 'Filtrer les conversations lue(s)',
    from: 'Depuis',
    typing: 'en train d\'écrire...',
    publicChannels: 'Canaux Publiques',
    privateChannels: 'Canaux Privés',
    publicChannel: 'Canal Publique',
    privateChannel: 'Canal Privé',
    directMessages: 'Messages Directs',
    openChat: 'Ouvrir le chat',
    search: 'Chercher une conversation',
    conversation: 'no conversation | 1 conversation | {count} conversations',
    messageOverlay: {
      notJoined: 'Vous n\'avez pas encore rejoint le canal <b>{roomName}</b>.',
      archived: 'Le canal <b>{roomName}</b> est archivé.'
    },
    advancedChat: {
      ROOMS_EMPTY: 'Aucune conversation',
      ROOM_EMPTY: 'Aucune conversation sélectionnée',
      NEW_MESSAGES: 'Nouveaux messages',
      MESSAGE_DELETED: 'Ce message a été supprimé',
      MESSAGES_EMPTY: 'Aucun message',
      CONVERSATION_STARTED: 'La conversation a commencée le :',
      TYPE_MESSAGE: 'Tapez votre message',
      SEARCH: 'Rechercher',
      IS_ONLINE: 'est en ligne',
      LAST_SEEN: 'dernière connexion ',
      IS_TYPING: 'est en train de taper...',
      CANCEL_SELECT_MESSAGE: 'Annuler Sélection'
    },
    roomType: {
      c: 'Publique',
      p: 'Privée',
      d: 'Message Direct'
    },
    roomActions: {
      replyMessage: 'Répondre',
      editMessage: 'Éditer',
      deleteMessage: 'Supprimer'
    },
    date: {
      now: 'à l\'instant',
      year: 'il y a 1 an | il y a  {count} ans',
      month: 'il y a 1 mois | il y a {count} mois',
      day: 'il y a 1 jour | il y a {count} jours',
      week: 'il y a 1 semaine | il y a  {count} semaines',
      hour: 'il y a 1 heure | il y a {count} heures',
      minute: 'il y a 1 minute | il y a {count} minutes',
      seconds: 'il y a 1 seconde | il y a {count} secondes'
    },
    // snake case
    contextMenu: {
      open: 'ouvrir',
      close: 'fermer',
      leave: 'partir',
      join: 'rejoindre',
      archive: 'archiver',
      restore: 'restorer',
      see_members: 'voir les membres',
      manage_members: 'gérer les membres',
      see_files: 'voir les fichiers',
      delete: 'supprimer',
      invite: 'inviter',
      kick: 'expulser',
      add_owner: 'promouvoir le propriétaire',
      remove_owner: 'retirer le propriétaire',
      rename: 'renommer',
      search_messages: 'Chercher un message',
      add_shared_contact: 'Ajouter aux contacts partagés',
      add_personal_contact: 'Ajouter aux contacts personnels',
      see_contact: 'Voir le contact',
      add_blacklist: 'Ajouter aux liste noire'
    },
    smsSettings: 'Parametres SMS',
    smsContextMenu: {
      title: 'Liste de SMS',
      filterMySmsDid: 'Filtrer avec mes numéros',
      filterSortBy: 'Trier par',
      properties: {
        recent_activity: 'Activité récente',
        alphabetically: 'Alphabétiquement'
      }
    },
    smsToEmails: {
      title: 'SMS vers courriels',
      email: 'Courriel',
      enabled: 'Active',
      phoneNumber: 'Numéro de téléphone',
      save: 'Sauvegarder',
      reset: 'Réinitialiser',
      notify: {
        saved: 'Votre configuration SMS vers courriel a été sauvegardé avec succès'
      },
      errors: {
        emailRequired: 'Le courriel est requis',
        emailInvalid: 'Le courriel est invalide',
        phoneNumberRequired: 'Le numéro de téléphone est requis'
      }
    },
    dmContextMenu: {
      title: 'Liste de direct message',
      filterSortBy: 'Trier par',
      properties: {
        recent_activity: 'Activité récente',
        alphabetically: 'Alphabétiquement'
      }
    },
    // global channels context menu
    channelsContextMenu: {
      title: 'Liste des canaux publiques',
      filterSortBy: 'Trier par',
      properties: {
        recent_activity: 'Activité récente',
        alphabetically: 'Alphabétiquement'
      }
    },
    // global channels context menu
    groupsContextMenu: {
      title: 'List des canaux privées',
      filterSortBy: 'Trier par',
      properties: {
        recent_activity: 'Activité récente',
        alphabetically: 'Alphabétiquement'
      }
    },
    newConversation: {
      title: 'Nouveau message',
      users: 'Utilisateur(s)',
      message: 'Message',
      uploadFiles: 'Téléverser un fichier',
      phoneNumber: 'Numéro de téléphone',
      fromDID: 'Envoyer avec le numéro de téléphone',
      conversationType: 'Type de conversation',
      channelType: 'Type de canal',
      private: 'Privé',
      public: 'Publique',
      channelName: 'Nom du canal',
      pickEmojis: 'Utiliser des emojis',
      errors: {
        specialCharacters: 'Ce champs ne peut pas contenir certains charactères spéciaux. Ces derniers seront remplacés par \'-\'.',
        fieldRequired: 'Ce champs est requis',
        fieldRequiredAndUniq: 'Ce champs est requis et doit être unique.'
      },
      btn: {
        cancel: 'Annuler',
        submit: 'Envoyer'
      }
    },
    members: {
      title: 'Membres dans',
      owner: 'Propirétaire',
      member: 'Membre',
      btn: {
        close: 'Fermer'
      }
    },
    availableUsers: {
      title: 'Utilisateur(s) disponible',
      selected: 'Sélectionné',
      member: 'Membre',
      btn: {
        cancel: 'Annuler',
        submit: 'Ajouter'
      }
    },
    renameChannel: {
      title: 'Renommer',
      btn: {
        cancel: 'Annuler',
        submit: 'Renommer'
      }
    },
    confirmDialog: {
      title: '{channelAction} ce canal?',
      message: 'Etes vous sur de vouloir {channelAction} le canal <span class="{textColor}">{channelName}</span>?',
      member: {
        message: {
          add_owner: 'Étes vous sur de vouloir promouvoir propriétaire l\'utilisateur <span class="{textColor}">{memberName}</span> dans le canal <span class="{textColor}">{channelName}</span>?',
          remove_owner: 'Étes vous sur de vouloir destituer le propriétaire <span class="{textColor}">{memberName}</span> dans le canal <span class="{textColor}">{channelName}</span>?',
          kick: 'Étes vous sur de vouloir retirer l\'utilisateur <span class="{textColor}">{memberName}</span> du canal <span class="{textColor}">{channelName}</span>?'
        }
      },
      btn: {
        cancel: 'Annuler'
      }
    },
    closeDm: {
      title: 'Fermer cette conversation?',
      message: 'Cela masquera cette discussion dans le menu de gauche, voulez-vous continuer?',
      btn: {
        cancel: 'Annuler',
        submit: 'Fermer'
      }
    },
    presence: {
      online: 'en ligne',
      offline: 'hors ligne',
      away: 'absent',
      busy: 'occupé',
      unknown: 'inconnu'
    }
  },
  unsupported: {
    title: 'Le navigateur n\'est pas supporté',
    note: 'Désolé, votre navigateur est trop ancien ou non compatible avec l\'application.',
    help: 'Veuillez mettre à jour votre navigateur, essayer un autre navigateur ou contacter le support technique.'
  },
  // SIP UA dialog box
  sipua: {
    title: 'Appel',
    box: {
      title: 'Connecter l\'appel en temps réel',
      dialfield: 'Numero à composer',
      btnhup: 'Raccrocher',
      callFrom: 'De',
      callTo: 'À'
    },
    error: {
      listenFail: 'La connexion d\'appel a échoué. L\'agent SIP n\'est pas connecté.',
      callFail: 'L\'appel à échoué',
      maxCallsOut: 'Limite d\'appels est {limit}. Impossible d\'initialiser un appel.',
      maxCallsIn: 'Max {limit} appels sont permis. L\'appel de "{fromName}" <{fromNum}> est annulé.',
      notSupported: 'Les appels Web ne fonctionnent pas parce que votre navigateur ne supporte ' +
        'pas WebRTC. Veuillez metre à jour votre navigateur ou verifier les paramètres de ' +
        'votre navigateur.',
      recDisabled: 'L\'enregistrement est désactivé',
      invalidNumber: 'Le numéro composé n\'est pas valide',
      invalidFeatureCode: 'Code spécial invalide'
    },
    hint: {
      ready: 'Prêt à faire un appel',
      calling: 'Appeler à {to}...',
      oncall: 'En appel avec {num}',
      missNum: 'Composez un numéro',
      notReady: 'L\'application SIP n\'est pas prête',
      incall: 'Appel entrant...'
    },
    notify: {
      title: 'Nouvel appel entrant',
      body: 'Appel de "{name}" <{num}>'
    },
    menu: {
      accept: 'Accepter',
      reject: 'Rejeter',
      hangup: 'Raccrocher',
      dialpad: 'Pavé de numérotation',
      volume: 'Son',
      parking: 'Parking',
      mute: 'Sourdine',
      hold: 'En attente',
      unhold: 'Activer',
      conf3w: '3-Way Conference',
      label3wc: 'Inviter un numèro',
      xfer: 'Transférer',
      vmail: 'Boîte vocale',
      callsLog: 'Historique',
      recStart: 'Enregistrer l\'appel',
      recStop: 'Arrêter l\'enregistrement'
    },
    xfer: {
      title: 'Transférer l\'appel à',
      title2: 'Transférer l\'appel',
      label: 'Transférer l\'appel à',
      placeholder: 'Numéro de téléphone',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      init: 'Transférer vers {num} initialisé...',
      success: 'Transfer vers {num} est réussi',
      park: 'L\'appel est connecté à parking lot',
      failed: 'Transférer vers {num} à échoué: {fail}'
    }
  },
  // Stats right navigation panel
  stats: {
    title: {
      nav: 'Stats',
      calls: 'Appels de la dernière heure',
      usersTotal: 'Nombre total d\'utilisateurs',
      onlineStatus: 'Connectés / Déconnectés',
      onCall: 'En ligne'
    },
    cdrApiFail: 'Le chargement de l\'historique d\'appels a échoué'
  },
  // queues page
  queues: {
    menuTitle: 'Files d\'Attentes',
    agentsTitle: 'Agents',
    callsTitle: 'Appels',
    dashboard: 'Tableau de bord',
    calls: {
      noCalls: 'Pas d\'appels actifs dans les files d\'attentes'
    },
    agent: {
      ignoreBusy: 'Ne pas faire sonner l\'agent occupé.',
      ringInUse: 'Fait sonner l\'agent en appel.',
      callsTaken: 'Appels répondus',
      respDelay: 'Délai de réponse',
      callerCall: 'Les agents en appels',
      chanspy: 'Écouter l\'appel d\'un agent (chan spy)'
    },
    redirect: {
      title: 'Prendre ou rediriger l\'appel de la file d\'attente',
      subtitle: 'Appel: {name} <{num}>',
      lblPickup: 'Prendre l\'appel',
      lblRedirect: 'Rediriger l\'appel',
      lblDest: 'Destination',
      lblPlacehdr: 'Veuillez choisir la destination',
      btnCancel: 'Annuler',
      btnPickup: 'Prendre',
      btnRedir: 'Rediriger',
      destError: 'Destination est requise',
      successRedir: 'Appel de {from} est regirigé vers {to}',
      pickupReqSent: 'La commande pour prendre l\'appel est envoyé'
    },
    tooltip: {
      watch: 'Commencer la surveillance.',
      listCalls: 'Appels dans la file d\'attente',
      allPause: 'Mettre tous les agents en pause',
      allUnpause: 'Re-activer tous les agents',
      hide: 'Cacher',
      agents: 'Details des agents et des appels',
      pause: 'Cliquez pour metre en pause l\'agent',
      unpause: 'Cliquez pour activer l\'agent',
      pauseNoPerm: 'Pas de permission pour mettre l\'agent en pause',
      inCalls: 'Les appels dans le file d\'attente',
      agentsOnCall: 'Les agents en appel',
      redirect: 'Rediriger l\'appel'
    },
    jumbotron: {
      watchHint: 'Ajouter les files d\'attentes.',
      title: 'Files d\'attentes',
      note: 'Les files d\'attentes de votre compte.'
    },
    body: {
      agents: 'Agents',
      agentsPaused: 'Agents en pause',
      agentsOnCall: 'Agents en appel',
      calls: 'Appels dans la file',
      holdtime: 'Temps d\'attente',
      completed: 'Appels terminés',
      abandoned: 'Appels abandonnés'
    },
    stats: {
      oncall: 'En appel',
      waiting: 'En attendant',
      completed: 'Appels terminés',
      abandoned: 'Appels abandonnés',
      agentsTotal: 'Agents totaux',
      agentsPaused: 'En pause',
      agentsUnpaused: 'Actif'
    },
    pauseDlg: {
      pauseAgent: 'Mettre l\'agent en pause',
      unpauseAgent: 'Activer l\'agent',
      pauseAll: 'Mettre tous les agents en pause',
      unpauseAll: 'Activer tous les agents',
      allAgents: 'Tous les agents',
      enableCause: 'Utiliser un statut personnalisé',
      hint: 'Nombre total de statuts de pause: ',
      label: 'Statut de pause',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      pauseCodes: {
        // use snake case for dynamic use from API
        lunch_break: 'Pause déjeuner',
        break: 'Pause',
        wrap_up_time: 'Finalise un appel',
        meeting: 'En réunion',
        clock_out: 'Pointer en partant'
      }
    },
    reports: {
      title: 'Rapports',
      tooltip: "Ouvrir les rapports de file d'attente",
      loading: 'Chargement des données du rapport',
      loadFail: 'Echec du chargement des données du rapport',
      unknownReportType: 'Type de rapport inconnu',
      noreport: "<strong>Rien ici pour l'instant!</strong><br />Choisissez vos filtres ci-dessus pour générer un rapport.",
      none: 'Aucun',
      emailReportFail: "Échec de l'envoi du rapport par e-mail",
      emailReportSuccess: "La génération du rapport a commencé. Vous recevrez un e-mail dès qu'il sera prêt.",
      emailDialog: {
        button: 'Rapport par e-mail',
        title: 'Rapport par e-mail',
        emailLabel: 'Destinataires',
        emailHint: 'Séparer les e-mails par des virgules',
        cancel: 'Annuler',
        submit: 'Envoyer le rapport'
      },
      filters: {
        showFilters: 'Afficher les filtres',
        hideFilters: 'Cacher les filtres',
        title: "Filtres des rapports de file d'attente",
        reportType: 'Type de rapport',
        queue: "File d'attente",
        plusMoreQueues: '(+{count} autres)',
        agent: 'Agent',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        timezone: 'Fuseau horaire',
        scope: 'Portée',
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        submit: 'Générer'
      },
      reportTypes: {
        queueSummary: "Résumé de la file d'attente",
        callDetails: 'Détaillé des appels',
        agentDetails: 'Détails des agents'
      },
      scopeOptions: {
        day: 'Jour',
        week: 'Semaine',
        month: 'Mois',
        custom: 'Personnalise'
      },
      scopeDisplays: {
        range: '<strong>{start}</strong> au <strong>{end}</strong>',
        hour: '<strong>{date}</strong> du <strong>{start}</strong> au <strong>{end}</strong>'
      },
      queueSummary: {
        title: "Rapport récapitulatif de la file d'attente",
        queueTitle: 'Totaux de file d\'attente',
        dateTitle: 'Calendrier',
        agentTitle: 'Agents',
        table: {
          queuename: "Nom de la file d'attente",
          date: 'Date',
          calls: 'Appels',
          answered: 'Répondus',
          abandon: 'Abandonnés',
          timeout: 'Temps mort',
          exit: 'Sortir',
          avgHold: 'Tenue Moy.',
          avgTalk: 'Conversation Moy.',
          maxTalk: 'Conversation Max',
          totalTalk: 'Totale',
          total: 'Totale'
        },
        chart: {
          failedLoad: 'Le graphique n\'a pas pu être chargé',
          exited: 'Sortie',
          timeout: 'Expiré',
          abandoned: 'Abandonnée',
          answered: 'Répondue'
        }
      },
      agent: {
        title: 'Rapport à l\'agent',
        summary: {
          agent: 'Agent',
          offered: 'Offert',
          answered: 'Répondus',
          minTime: 'Temps Min.',
          avgTime: 'Temps Moyen',
          maxTime: 'Temps Max.',
          totalTime: 'Total',
          total: 'Total'
        },
        details: {
          time: 'Date/Heure',
          event: 'Evenement',
          callerId: 'Identification d\'appel',
          queue: 'File d\'attente',
          holdTime: 'Temps Maintien',
          duration: 'Durée'
        }
      },
      callDetails: {
        title: 'Rapport détaillé des appels',
        table: {
          dateTime: 'Date/Heure',
          queue: 'File d\'attente',
          callerId: 'Identifiant d\'appel',
          callStatus: 'Statut',
          agents: 'Agent',
          holdTime: 'Temps de maintien',
          callDuration: 'Durée',
          total: 'Total'
        },
        details: {
          title: 'Événements d\'appel',
          loading: 'Chargement des détails des événements par appel',
          loadFail: 'Echec du chargement des détails des événements par appel',
          table: {
            time: 'Heure',
            queue: 'File d\'attente',
            callerId: 'Identifiant d\'appel',
            event: 'Evenement',
            agent: 'Agent',
            wait: 'Attente',
            duration: 'Durée'
          }
        },
        statuses: {
          notMapped: 'N/A',
          ABANDON: 'Abandonné',
          COMPLETEAGENT: 'Répondue',
          COMPLETECALLER: 'Répondue',
          CONNECT: 'Connecté',
          EXITEMPTY: 'Sortie vide',
          EXITWITHKEY: 'Pression de touche',
          EXITWITHTIMEOUT: 'Timeout',
          inQue: 'En file d\'attente'
        }
      },
      eventDetails: {
        events: {
          notMapped: 'N/A',
          ABANDON: 'Abandonné',
          ADDMEMBER: 'Ajouter un membre',
          COMPLETEAGENT: 'Agent terminé',
          COMPLETECALLER: 'Appelant terminé',
          CONFIGRELOAD: 'Redémarrer la configuration',
          CONNECT: 'Connecté',
          ENTERQUEUE: 'Entrée dans la file d\'attente',
          EXITEMPTY: 'Sortie vide',
          EXITWITHKEY: 'Sortie avec clé',
          EXITWITHTIMEOUT: 'Sortie avec timeout',
          PAUSE: 'Mettre en pause',
          PAUSED: 'En pause',
          QUEUESTART: 'Debut de la file d\'attente',
          REMOVEMEMBER: 'Supprimer un membre',
          RINGCANCELED: 'Cancellé',
          RINGNOANSWER: 'Non répondu',
          UNPAUSE: 'Activer',
          UNPAUSED: 'Actif',
          AGENTLOGIN: 'Agent activé',
          AGENTLOGOUT: 'Agent désactivé',
          ATTENDEDTRANSFER: 'Transfert d\'attente',
          BLINDTRANSFER: 'Transfert au clé',
          AGENTDUMP: 'Dump de l\'agent',
          SYSCOMPAT: 'Compatibilité du système',
          PAUSEALL: 'Mettre en pause tous les agents',
          UNPAUSEALL: 'Activer tous les agents',
          PENALTY: 'Penalité',
          RINGINUSE: 'Appel en cours',
          WITHDRAW: 'Retirer',
          OUTCALL: 'Sortie d\'appel'
        }
      }
    }
  },
  availableExtensions: {
    title: 'Postes disponibles',
    extension: 'Poste',
    usernameToSearch: 'Chercher un poste disponible'
  },
  videoconf: {
    menuTitle: 'Conférence Video',
    emptyTitle: 'Choisissez la conférence video',
    emptyText: 'Vous n\'avez pas encore de vidéo conférence.',
    loading: 'Connexion conférence "{room}"',
    rejoin: 'Re-connexion de la conférence "{room}"',
    disconnect: 'La conférence "{room}" est déconnectée',
    filters: 'Filtre de conférence dynamique',
    extension: 'Poste {extension}',
    btn: {
      create: 'Créer une conférence video'
    },
    participantsDialog: {
      btn: {
        close: 'Fermer'
      },
      title: 'Membres dans <b>{name}</b>',
      admin: 'Admin',
      member: 'Membre'
    },
    aboutDialog: {
      btn: {
        close: 'Fermer'
      },
      title: 'A propos de <b>{name}</b>'
    },
    deleteDialog: {
      btn: {
        delete: 'Supprimer',
        cancel: 'Annuler'
      },
      title: 'Supprimer une conférence vidéo',
      message: 'Etes vous sur de vouloir supprimer la conférence vidéo <b>{name}</b>?'
    },
    optionsContextMenu: {
      update: 'Mettre à jour',
      delete: 'Supprimer',
      about: 'A propos',
      seeParticipants: 'Voir les participants'
    },
    form: {
      update: 'Mettre à jour',
      create: 'Crée',
      cancel: 'Annuler',
      required: 'Requis',
      invalidName: 'Nom invalide',
      pick: 'Choisir',
      general: 'Général',
      shareScreen: 'Partage d\'écran',
      recording: 'Enregistrement',
      telephony: 'Téléphonie',
      emptyAdminPlaceholder: 'Laissez vide pour aucun administrateur',
      emptyUserPlaceholder: 'Laissez vide pour inclure tous les utilisateurs',
      prompt: 'Joindre la conférence par téléphone',
      fields: {
        name: 'Nom',
        expireAt: 'Expire le',
        admins: 'Admins',
        users: 'Utilisateurs',
        roomNumber: 'Identifiant',
        roomPin: 'NIP',
        enableForAdmin: 'Activé pour administrateur(s)',
        enableForGuest: 'Activé pour invité(s)',
        callerIdName: 'Identifiant d\'appel: nom',
        callerIdNumber: 'Identifiant d\'appel: numéro',
        username: 'Poste',
        validations: {
          expireAt: {
            required: 'La date d\'expiration est requise',
            min: 'La date d\'expiration minimal doit etre {date}'
          }
        }
      }
    },
    tooltip: {
      admin: 'Vous êtes un administrateur de cette conférence',
      excludeDynamic: 'Filtrer les vidéo conférences dynamiques',
      includeDynamic: 'Ne pas filter les vidéo conférences dynamiques',
      expireAt: 'L\'heure d\'expiration de la conférence',
      expired: 'La conférence est expiré',
      join: 'Rejoindre la conférence "{name}"',
      openNew: 'Ouvrir dans un nouvel onglet',
      hangup: 'Raccrocher',
      minimize: 'Réduire',
      expand: 'Détacher',
      fullscreen: 'Plein écran',
      copyGuestLink: 'Copier the lien invité de la conférence dans votre prespapier',
      small: 'Mode ancré',
      license: 'Nombre de conférence(s): {total}, License: {license}, Authorisé sur le système: {global}',
      unlimited: 'Illimité'
    },
    info: {
      title: 'A propos de cette conférence',
      info: 'Information',
      value: 'Valeur',
      items: {
        participant_in_meeting: 'Utilisateur(s) en conférence',
        users_count: 'Utilisateurs',
        guest_url: 'URL de la conférence',
        expireAt: 'Expire le',
        phone_numbers: 'Numéro(s) de téléphone',
        admins_count: 'Administrateur(s)',
        extension: 'Poste',
        sharedScreenAdmin: 'Partage d\'écran pour admin(s)',
        sharedScreenGuest: 'Partage d\'écran pour invité(s)',
        recordingAdmin: 'Enregistrement pour admin(s)',
        recordingGuest: 'Enregistrement pour invité(s)',
        roomNumber: 'Identifiant pour joindre la conférence par téléphone',
        roomPin: 'NIP pour joindre la conférence par téléphone',
        enabled: {
          true: 'Activé',
          false: 'Désactivé'
        }
      }
    },
    users: {
      title: 'Utilisateurs',
      name: 'Nom',
      status: 'Statut',
      online: 'En Conférence',
      offline: 'Hors Ligne'
    },
    msg: {
      joined: 'Vous avez rejoint la conférence',
      left: 'Vous avez quitté la conférence',
      connecting: 'Connexion en cours...',
      copy: {
        success: 'Copié avec succès',
        error: 'Une erreur est survenue pendant la copie'
      }
    }
  },
  // conferences page
  confr: {
    menuTitle: 'Conférences',
    capacity: 'Capacité',
    members: 'Members',
    pin: 'NIP d\'utilisateur',
    adminpin: 'NIP d\'admin',
    exten: 'Poste',
    kick: 'Enlever le conférence membre',
    mute: 'Couper le son du membre',
    personal: {
      title: {
        card: 'Conférence personnelle',
        form: 'Paramétrers',
        data: 'Ma conférence personnelle',
        opt: 'Options'
      },
      disabledTooltip: 'La conférence personnelle est désactive. ' +
        'Veuillez activer la conférence dans la fenetre des paramètres.',
      settings: {
        saveOk: 'Les paramètres de la conférence personnelle sont enregistrés',
        btn: {
          save: 'Sauvegarder',
          cancel: 'Annuler'
        },
        btnTooltip: 'Paramétrer la conférence personnelle',
        label: {
          activate: 'Activer ma conférence personnelle',
          userPin: 'NIP Utilisateur',
          maxUsers: 'Nombre maximum d\'utilisateurs (incluant Admin)',
          countSay: 'Annoncer le nombre de participants',
          moh: 'Attente musicale',
          waitAdmin: 'Attendre l\'arrivée de l\'administrateur pour commencer',
          joinSay: 'Annoncer l\'arrivée/départ d\'un participant',
          openMenu: 'Écouter les options à l\'appui de la touche "*"',
          listenOnly: 'Mode écoute (utilisateurs)'
        },
        error: {
          invalPIN: 'NIP est requis et doit être numerique',
          maxUsersNum: 'Le nombre maximum d\'utilisateurs doit être numerique',
          maxUsersInval: 'Ce paramètre doit être 0 ou plus. 0 = illimité',
          noPerm: 'Vous n\'avez pas la permission pour changer votre conférence personnel'
        }
      }
    },
    inv: { // invite into conference
      title: 'Inviter à la conference',
      lable: 'Numéro à inviter',
      invalid: 'Numéro est invalid',
      cancel: 'Annuler',
      invite: 'Inviter'
    },
    tooltip: {
      watch: 'Commencer la surveillance.',
      btnCall: 'Appeler la conférence',
      btnMems: 'Lister les utilisateurs actuellement en conférence',
      btnNoMember: 'Aucun utilisateur n\'est dans la conférence en ce moment',
      invite: 'Inviter à le conférence',
      isInvited: 'Ce membre est invité',
      isAdmin: 'L\'administrateur de la conference',
      dndOver: 'Transfert l\'appel à le conférence {name}',
      close: 'Fermer'
    },
    jumbotron: {
      title: 'Conférences',
      note: 'Liste des conférences actives.'
    }
  },
  // parking page
  parking: {
    menuTitle: 'Parking',
    freeSlot: 'Libre',
    dropToPark: 'Parquer ici',
    directPark: 'Parquer l\'appel vers l\'emplacement <{slot}>',
    jumbotron: {
      title: 'Postes de stationnement',
      note: 'Les appels parqués s\'il y a'
    },
    label: {
      parkedBy: 'Parqué par',
      parkedCall: 'Appel parqué',
      parkedAt: 'Parqué à'
    },
    tooltip: {
      space: 'L\'appel est parqué sur poste stationnement',
      retrieveCall: 'Récupérer l\'appel parqué sur poste stationnement'
    }
  },
  // voicemail page
  vmail: {
    menuTitle: 'Boîte Vocale',
    loading: 'Chargement des messages vocaux',
    searchPlaceholder: 'Chercher un message vocal',
    filters: 'Filtres',
    vmb: 'Boîte Vocale',
    forceTranscriptionEnableDialog: {
      title: 'Transcription désactivée',
      text: 'Vos messages vocaux ne seront pas résumé ni transcrit',
      buttons: {
        enable: 'Activer',
        later: 'Plus tard',
        never: 'Jamais'
      }
    },
    detail: {
      pages: '{0} sur {1}',
      errors: {
        noVoicemailFound: 'Aucun message vocal trouvé'
      }
    },
    moveToCustomFolder: {
      title: 'Déplacer vers dossier personnalisé',
      vmbSelectBoxesLabel: 'boite vocales',
      bulkTitle: 'Déplacer vers dossier personnalisé',
      bulkIntro: 'Déplacer {count} messages vocaux vers un dossier personnalisé',
      folderLabel: 'Crée ou sélectionnez un dossier personnalisé',
      folderPlaceholder: 'Crée ou sélectionnez un dossier personnalisé',
      btnCancel: 'Annuler',
      btnMoveToCustomFolder: 'Déplacer',
      errors: {
        folderNameRequired: 'Le nom du dossier est requis',
        invalidFolderName: 'Seuls les lettres sont autorisées (3-10 caractères)',
        reservedFolderName: 'Ce nom de dossier est réservé et n\'est pas autorisé.'
      }
    },
    listToolbar: {
      labels: {
        folder: 'Dossier',
        category: 'Catégory',
        search: 'Recherche',
        dateLabel: 'Filtre par date',
        datePlaceholder: 'Choisissez une date'
      }
    },
    tip: {
      noData: 'Aucun message vocal trouvé',
      noSummary: '(Résumé indisponible)',
      refreshVm: 'Rafraîchir la liste des messages vocaux',
      addToFavorites: 'Ajouter aux favoris',
      removeFromFavorites: 'Supprimer des favoris',
      deleteVoicemail: 'Supprimer le message vocal',
      markUnread: 'Marquer comme non lu',
      markRead: 'Marquer comme lu',
      forwardVoicemail: 'Transférer le message vocal',
      toggleReadUnread: 'Changer le statut lu / non lu'
    },
    footerProps: {
      pageText: '{0}-{1} de {2}',
      perPage: 'Par page'
    },
    jumbotron: {
      title: 'Boîte Vocale',
      note: 'Liste des message voceaux.'
    },
    title: {
      vmNew: 'Nouveaux messages',
      selectBox: 'Choisir la boîte vocale',
      vmOld: 'Messages lus',
      transcription: 'Transcription',
      summary: 'Résumé',
      translation: 'Tranduction'
    },
    btn: {
      editGreetAudio: "Editer l'audio",
      play: 'Lire',
      del: 'Suprimer',
      markRead: 'Marquer lu',
      markUnread: 'Marquer non lu',
      call: 'Rappeler',
      nocall: 'Le numero est invalide',
      xfer: 'Transférer',
      removeFromFavorites: 'Supprimer des favoris',
      addToFavorites: 'Ajouter aux favoris',
      readAsText: 'Lire en texte',
      bulk: '{count} sélectionnés',
      favorite: 'Favoris',
      unfavorite: 'Supprimer des favoris',
      displayOrigTranscription: 'Afficher le texte original',
      moveToCustomFolder: 'Déplacer vers un dossier personnalisé',
      removeFromCustomFolder: 'Retirer du dossier personnalisé',
      goBack: 'Retour'
    },
    myvms: 'Mes messages',
    help: {
      readAsText: 'Lire la version texte de ce message vocal'
    },
    categories: {
      all: 'Tout',
      solicitation: 'Sollicitation',
      political: 'Politique',
      personal: 'Personnel',
      medical: 'Médicale',
      fraud: 'Fraude',
      emergency: 'Urgence',
      travel: 'Voyage',
      misc: 'Divers'
    },
    hdrs: {
      menu: 'Menu',
      folder: 'Dossier',
      category: 'Catégorie',
      play: 'Écouter',
      time: 'Date',
      cidName: 'Nom de l\'appelant',
      cidNum: 'Numero de l\'appelant',
      duration: 'Durée du message',
      readAsText: 'Lire en texte',
      transcriptionCategory: 'Categorie',
      summary: 'Résumé'
    },
    folder: {
      all: 'Tous',
      inbox: 'Entrants',
      old: 'Anciens',
      favorite: 'Favoris'
    },
    cfg: {
      btnSave: 'Sauvegarder',
      filter: {
        tab: 'Filtre',
        selectBox: 'Choisir boîte vocale',
        selectBoxes: 'Choisir boîtes vocales',
        selectDate: 'Date du message'
      },
      settings: {
        tab: 'Paramètres',
        email: 'Courriel',
        pager: 'Courriel / Numéro SMS pour téléavertisseur',
        pin: 'Mot de passe boîte vocale',
        attach: 'Pièce jointe',
        delvm: 'Enlever message',
        playcid: 'Jouer CID',
        envelope: 'Jouer Envelope',
        skipInstruct: 'Ignorer les instructions de la BV',
        transcript: 'Activer la transcription',
        summarize: 'Activer le résumé',
        categorize: 'Activer la catégorie',
        translate: 'Activer la traduction'
      },
      greeting: {
        tab: "Messages d'accueil",
        name: 'Nom',
        busy: 'Occupé',
        unavail: 'Non disponible',
        temp: 'Temporaire',
        recdur: 'Durée d\'enregistrement',
        rectime: 'Heure et date de l\'enregistrement',
        defaults: 'PBX par défaut',
        btnReset: 'Réinitialiser',
        btnRestore: 'Restaurer',
        btnUpload: 'Téléverser',
        btnRecord: 'Enregistrer',
        btnTTS: 'Texte',
        btnCancel: 'Annuler',
        btnClose: 'Fermer',
        btnSave: 'Enregistrer',
        updated: '"{name}" a été mis à jour',
        confirmTitle: 'Réinitialiser l\'enregistrement?',
        confirmMsg: 'L\'enregistrement "<strong>{name}</strong>" sera enlevé' +
          ' et l\'enregistrement sera réinitiatilisé par défaut.',
        archive: {
          title: 'Restaurer de l\'archive',
          subtitle: 'Remplacer le message "{name}"',
          label: 'Archiver avant réinitialiser',
          name: 'Nom de l\'archive',
          btnRestore: 'Restaurer',
          nameRequired: 'Nom de l\'archive est requis',
          ttStop: 'Arrêter',
          ttPlay: 'Jouer l\'enregistrement',
          success: 'L\'archive est rétabli'
        },
        rec: {
          title: 'L\'enregistrement "{name}"',
          failMediaTitle: 'Source audio n\'est pas trouvé',
          failMediaMsg: 'Source audio virtuelle comme un microphone n\'est pas trouvé. ' +
            'Veuillez vérifier votre micro et rafraîchir la page ' +
            'ou redémarrer navigateur',
          failMediaPermission: "L'utilisation du microphone a été refusée."
        },
        upload: {
          title: 'Télécharger "{name}"',
          label: 'Seulement fichier WAV'
        },
        tts: {
          title: 'Synthèse vocale',
          cancel: 'Annuler',
          save: 'Sauvegarder'
        },
        notify: {
          archived: 'L\'archivage est réussi',
          reset: 'Réinitialisation est réussi'
        },
        default: {
          name: '{name}',
          busy: 'Vous avez atteint la messagerie de {name}, qui est actuellement en ligne. Veuillez laisser un message après le bip.',
          unavailable: 'Vous avez atteint la messagerie de {name}. Veuillez laisser un message après le bip.',
          temp: 'Vous avez atteint la messagerie de {name}. Veuillez laisser un message après le bip.'
        }
      },
      err: {
        email: 'Email invalide',
        pager: 'Email / Numéro SMS invalide',
        pin: 'Mot de passe invalide. Chiffres suelement',
        pinln: 'Mot de passe invalide: doit contenir {min} à {max} chiffres',
        uploadType: 'Le type du fichier est invalide. Seulement type WAV.',
        uploadSize: 'Le taille de fichier max est 2Mb',
        valueNotGreaterThan: 'La valeur doit être supérieur à {value}.'
      }
    },
    xfer: {
      title: 'Transférer le message',
      destinationLabel: 'Destination du transfert',
      destinationPlaceholder: 'Nom ou extension...',
      bulkTitle: 'Transférer des messages',
      bulkIntro: 'Transférer {count} messages vers la destination:',
      btnCancel: 'Annuler',
      btnXfer: 'Transférer'
    },
    del: {
      title: 'Supprimer le message',
      bulkTitle: 'Supprimer des messages',
      bulkConfirm: 'Confirmer la suppression de {count} messages ?',
      btnCancel: 'Annuler',
      btnDel: 'Supprimer'
    },
    notify: {
      savedOk: 'Les parameters de boîte vocale sont enregistrés',
      saveFail: 'La mise à jour de paramètres de voicemail a échoué',
      xferOk: 'Le message vocal "{callerid}" est transféré à {to}',
      bulkMarkReadOk: '{count} messages marqués lu',
      bulkMarkUnreadOk: '{count} messages marqués non lu',
      bulkXferOk: '{count} messages transférés à {to}',
      bulkDelOk: '{count} messages supprimés',
      hasMultipleWatchers: 'Plusieurs boîtes vocales sélectionnées',
      noReadPerms: 'Aucune autorisation pour voir les paramètres de la messagerie vocale'
    }
  },
  // announcements
  announce: {
    menuTitle: 'Enregistrements',
    emptyPlaceholder: 'Vos annonces audio seront listés ici.',
    searchPlaceholder: 'Chercher une annonce',
    loading: 'Chargement des annonces',
    tip: {
      noData: 'Aucune annonce trouvée'
    },
    footerProps: {
      pageText: '{0}-{1} sur {2} annonces',
      total: 'Nombre total d\'annonces par page'
    },
    columns: {
      name: 'Nom',
      pin: 'NIP',
      voiceType: 'Type de voix',
      voiceCategory: 'Catégorie de voix',
      voiceLanguage: 'Language de la voix',
      formattedPostDest: 'Destination suivant l\'annonce',
      lang: 'Langage de la destination',
      textToSpeech: 'Text To Speech',
      pitch: 'Pitch TTS',
      speed: 'Vitesse TTS',
      volumeGainDb: 'Gain de volume TTS',
      ttsLanguage: 'Langage TTS',
      textType: 'Type de TTS',
      actions: 'Actions'
    },
    columnRenderer: {
      yes: 'Oui',
      no: 'Non',
      copy: 'Copier',
      copied: 'Copié',
      voiceCategories: {
        standard: 'Basique',
        news: 'Actualités',
        wavenet: 'WaveNet',
        polyglot: 'Polyglotte',
        chirpHD: 'Chirp HD',
        chirp3HD: 'Chirp3 HD',
        studio: 'Studio',
        neural2: 'Neural2'
      },
      channelTypes: {
        text: 'Texte brute',
        ssml: 'SSML'
      }
    },
    tts: {
      buildBtn: 'Générer et écouter'
    },
    edit: {
      title: 'Annonce mis à jour',
      name: 'Nom',
      pin: 'NIP',
      lang: 'Langue',
      required: 'Ce champ ne peut être vide',
      requiredForTTS: 'Ce champs est requis pour TTS',
      ttsMaxLength: 'Le texte TTS doit contenir {max} caractères ou moins',
      numeric: 'NIP doit être un nombre',
      t2s: 'Text à convertir en fichier audio',
      cancel: 'Annuler',
      update: 'Mettre à jour'
    },
    upload: {
      title: 'Téléverser un fichier d\'annonce',
      file: 'Téléverser un fichier',
      hint: 'Choisissez un fichier wav ou mp3',
      required: 'D\'un fichier est requis',
      cancel: 'Annuler',
      btnUpload: 'Téléverser'
    },
    recording: 'Enregistrer',
    ttip: {
      upload: 'Sélectionner un fichier',
      record: 'Enregistrer une annonce',
      reset: 'Réinitialiser l\'annonce'
    },
    tabRec: 'Enregistrer',
    tabT2S: 'Text-to-Speech',
    loadError: 'Téléchargement de l\'enregistrement est échoué',
    noWritePerm: 'Vous n\'avez pas les droits pour changer l\'annonce. ' +
      'Veuillez contacter le support technique'
  },
  contacts: {
    menuTitle: 'Contacts',
    featureCode: 'Code spécial',
    featureCodes: {
      vm: 'Boite vocales',
      myvm: 'Ma boîte vocale',
      recording: 'Nouvelle annonce',
      echo: 'Écho',
      anonymouscall: 'Appel anonyme',
      leave_voicemail: 'Laisser un message vocal',
      chan_spy: 'Espionner',
      timecondition_switch: 'Changer condition temporelle',
      personalconf: 'Conférence personnelle',
      agentlogin: 'Activation/désactivation des agents de files d\'attente',
      moh: 'Musique en attente',
      adhoc: 'Ad Hoc',
      unadhoc: 'Non Ad Hoc',
      qoffall: 'Activation/désactivation de tous les agents de files d\'attente',
      toggle: 'Destination alternative',
      dnd: 'Ne pas déranger',
      forward: 'Transfert',
      followme: 'Suivez-moi',
      intercom: 'Interphone',
      silenticom: 'Interphone silencieux',
      call_blind_transfer: 'Transfert aveugle',
      directed_call_pickup: 'Prise d\'appel dirigée',
      on_demand_call_recording: 'Enregistrer un appel',
      tcswitch: 'Changer condition temporelle',
      blacklist_number_add: 'Ajouter un numéro à la liste noire',
      blacklist_number_remove: 'Retirer un numéro de la liste noire',
      blacklist_number_add_last_caller: 'Ajouter le dernier appel recu à la liste noire'
    },
    loading: 'Chargement. Veuillez patienter...',
    total: 'Nombre total de contacts: {n}',
    searchPlaceholder: 'Rechercher des contacts',
    createSuccess: 'Contact crée avec succès',
    updateSuccess: 'Contact mis à jour avec succès',
    deleteSuccess: 'Contact supprimé avec succès',
    footerProps: {
      pageText: '{0}-{1} sur {2} contacts',
      total: 'Nombre total de contacts par page'
    },
    tip: {
      noData: 'Aucun contact trouvé'
    },
    tagForm: {
      name: 'Nom'
    },
    formValidation: {
      required: 'Ce champs est requis',
      lettersOnly: 'Le champs doit contenir des lettres seulement',
      numericOnly: 'Le champs doit contenir des chiffres seulement',
      minimumChar: 'Le champs doit contenir au moins {min} lettres',
      minimumDigit: 'Le champs doit contenir au moins {min} chiffres',
      validEmail: 'Le champs doit être un courriel valide'
    },
    tagDeleteForm: {
      confirmation: 'Êtes vous sur de vouloir supprimer le tag',
      // pluralization support, use $tc instead of $t
      inUseMessage: 'Aucun contact utilise ce tag. | {inUseCount} utilise ce tag. | {inUseCount} contacts utilisent ce tag.'
    },
    detailsDialog: {
      title: 'Détails du contact',
      address: 'Adresse',
      openMap: 'Ouvrir sur Maps'
    },
    deleteForm: {
      confirmation: 'Êtes vous sur de vouloir supprimer le contact partagé',
      confirmationPersonal: 'Êtes vous sur de vouloir supprimer le contact personnel'
    },
    form: {
      addressTypes: {
        home: 'Maison',
        work: 'Travail',
        school: 'École',
        other: 'Autre'
      }
    },
    errors: {
      load: 'Une erreur est survenue pendant le chargement des contacts'
    },
    importForm: {
      title: 'Importer',
      fileField: 'Choisissez un fichier CSV',
      notice: '<p> Vous voulez importer des nouveaux utilisateurs ? </p> <ul><li>Exportez vos utilisateurs existant. Cela vous donnera une architecture CSV valide et vous aurez plus qu\'à travailler sur ce fichier. De plus, certaines informations comme phone model ID, provionning template ID ou user profile ID sont uniquement accessible depuis un CSV exporté.</li><li>Le champs ID doit rester vide pour la création d\'utilisateurs.</li><li>Web password, Phone secret et Voicemail Pin sont obligatoires lors de la création.</li><li>Vous pouvez ignorer le champs IP address.</li><li>Pour rappel, un CSV valide a chacune de ses valeurs séparées par des virgules.</li><li>Pour les valeurs issues de l\'onglet \'statut\', vueillez vous assurer que le profil utilisateur sélectionné authorise ces fonctionnalitées.</li><li>Pour les fonctionnalités \'Ne pas déranger\' et \'appels en attente\', les valeurs valident sont 0 et 1.</li></ul><p> Vous voulez mettre à jour des utilisateurs? </p><ul><li>Exportez vos utilisateurs existant et éditez les !</li><li>Les mots de passe ne sont pas obligatoires</li><li>Pour rappel, un CSV valide a chacune de ses valeurs séparées par des virgules.</li></ul>'
    },
    columns: {
      name: 'Nom, Prénom',
      email: 'Courriel',
      emails: 'Courriels',
      firstName: 'Prénom',
      lastName: 'Nom',
      company: 'Compagnie',
      jobTitle: 'Position',
      addressType: 'Type d\'adresse',
      street: 'Adresse',
      city: 'Ville',
      state: 'État / Province / Région',
      postalCode: 'Code postale',
      country: 'Pays',
      tags: 'Tags partagés',
      isPersonal: 'Ce contact est personnel',
      personalTags: 'Tags personnels',
      image: 'Photo de profil',
      phoneNumber: 'Numéro de téléphone',
      phoneNumbers: 'Numéros de téléphone',
      useAsCallerid: 'Utiliser en afficheur',
      cellRenderer: {
        boolean: {
          true: 'Oui',
          false: 'Non'
        }
      }
    },
    btn: {
      newContact: 'Créer un contact',
      sharedContacts: 'Contacts partagés',
      personalContacts: 'Contacts personnels',
      export: 'Exporter',
      import: 'Importer',
      print: 'Imprimer',
      createTag: 'Créer un tag',
      createPersonalTag: 'Créer un tag personnel',
      create: 'Créer',
      update: 'Mettre à jour',
      delete: 'Supprimer',
      cancel: 'Annuler',
      bulk: '{count} sélectionnés'
    },
    conversation: 'no conversation | 1 conversation | {count} conversations',
    confirmBulkDelete: {
      title: 'Supprimer des contacts',
      message: 'Aucun contact à supprimer | Êtes vous sur de vouloir supprimer ce contact? | Êtes vous sur de vouloir supprimer ces {count} contacts?'
    },
    notify: {
      createdOk: 'Le contact a été crée avec succès',
      updatedOk: 'Le contact a été crée avec succès',
      deletedOk: 'Le contact a été supprimé avec succès',
      bulkDelOk: '{count} contacts supprimés avec succès'
    }
  },
  // cdrs page
  cdrs: {
    menuTitle: 'Historique d\'appels',
    loading: 'Chargement. Veuillez patienter...',
    total: 'Nombre total d\'enregistrements: {n}',
    footerProps: {
      pageText: '{0}-{1} sur {2} appels',
      total: 'Nombre d\'appels par page'
    },
    columns: {
      from: 'Appelant',
      to: 'Appelé',
      duration: 'Durée'
    },
    err: {
      load: 'Erreur de chargement',
      recNotFound: 'Enregistrement introuvable'
    },
    tip: {
      incoming: 'Appels sortants',
      outgoing: 'Appels entrants',
      noData: 'Aucun appel trouvé sur cette période',
      failed: 'L\'appel a échoué'
    },
    btn: {
      callback: 'Rappeler',
      playrec: 'Écouter l\'enregistrement',
      download: 'Télécharger l\'enregistrement',
      bulk: '{count} sélectionnés',
      close: 'Fermer'
    },
    filter: {
      extensions: 'Extensions',
      allExtensions: 'Toutes',
      startDate: 'Début',
      endDate: 'Fin'
    },
    numLabel: {
      vm: 'Boîte vocale',
      conf: 'Conférence',
      myconf: 'Conférence Personale',
      park: 'Parking lot',
      parkPickup: 'Parking pickup',
      queue: 'File d\'attente',
      jitsi: 'Conférence Jitsi'
    },
    recordings_download: {
      title: 'Téléchargement d\'enregistrements d\'appels',
      success: 'Nous préparons votre archive d\'enregistrements. Vous recevrez une notification par courriel lorsqu\'elle sera prête à être téléchargée.',
      error: 'Une erreur est survenue lors de la préparation de votre archive d\'enregistrements.'
    }
  },
  // settings page
  settings: {
    menuTitle: 'Paramètres',
    callWaiting: 'Appel en attente',
    intercom: 'Interphone accepter',
    icomDesk: 'Interphone accepter pour téléphone fixe',
    icomCallpanel: 'Interphone accepter pour CallPanel',
    icomAnywhere: 'Interphone accepter pour Anywhere',
    dnd: 'Ne pas déranger',
    showMissedCalls: 'Afficher les appels manqués',
    errors: {
      missingPermissions: 'Permissions manquantes'
    },
    drawer: {
      phoneStatus: 'État du téléphone',
      devices: 'Appareils & médias',
      account: 'Compte',
      softphone: 'Clearly Anywhere',
      emergency: 'Urgence',
      notifications: 'Notifications',
      clickToDial: 'Cliquez pour composer',
      callScreenPop: "Fenêtre contextuelle d'appel",
      stunServers: 'Serveurs STUN'
    },
    notifications: {
      title: 'Notifications',
      enabled: 'Activer',
      timeout: 'Délai d\'expiration'
    },
    notify: {
      dndOn: 'Ne pas déranger est activé',
      dndOff: 'Ne pas déranger est désactivé',
      cwOn: 'Appel en attente est activé',
      cwOff: 'Appel en attente est désactivé',
      icomOn: 'Intercom activé pour {icom}',
      icomOff: 'Intercom désactivé pour {icom}',
      fwdSaved: 'Paramètres renvoi d\'apel sont enregistrés',
      fwdOff: 'Renvoi d\'appel est désactivé',
      fmeSaved: 'Paramètres du suivez-moi enregistrés',
      fmeOff: 'Suivez-moi désactivé',
      ctdSaved: 'Paramètres click-to-dial enregistrés',
      screenPopSaved: 'Paramètres fenêtre contextuelle d\'appel enregistrés',
      stunServersSaved: 'Paramètres de serveurs STUN enregistrés'
    },
    fme: {
      ringStrategy: {
        label: 'Stratégie d\'appel',
        strategies: {
          ringall: 'Sonner tous les postes',
          hunt: 'Sonner les postes séquentiellement',
          memoryhunt: 'Sonner les postes séquentiellement avec mémoire'
        }
      },
      title: 'Suivez-moi',
      save: 'Sauvegarder',
      prefix: 'Préfixe d\'afficheur',
      confirm: 'Confirmer l\'appel',
      markanswered: 'Marquer comme répondu ailleurs',
      ringFirst: 'Délai entre les appareils (sec)',
      ringAll: 'Délai avant arrêt (sec)',
      num: 'Numéro ou poste',
      addNumBtn: 'Ajout',
      noData: 'Le numéro n\'est pas mis',
      errInvalid: 'Le numéro n\'est pas valide.',
      errMax: 'Cinq numéros maximum peuvent être ajoutés',
      errExists: 'Le numéro {num} est déjà ajouté',
      showMore: 'Afficher les paramètres avancés',
      prefixPlaceholder: 'Exemple: Travail',
      seconds: 'sec',
      errTimeoutTooBig: '{timeout}s is too big. The maximum allowed is 100s.',
      errTimeoutTooSmall: '{timeout}s is too small. The minimum allowed is 0s.',
      labels: {
        numbers: 'Destinations \'Suivez-moi\'',
        cid: 'Afficheur',
        timeouts: 'Délai d\'activation'
      },
      clid: {
        label: 'Paramétrisation de l\'afficheur',
        externCIDName: 'Nom sur l\'afficheur',
        externCIDNum: 'Numéro sur l\'afficheur',
        useUser: 'Utiliser l\'afficheur externe de l\'utilisateur',
        useInbound: 'Utiliser l\'afficheur entrant depuis un numéro externe',
        useCustom: 'Utiliser un afficheur personnalisé'
      },
      tc: { // time conditions
        label: 'Condition temporelle',
        none: 'Non'
      }
    },
    blacklist: {
      title: 'Liste Noire',
      name: 'Nom du numéro blacklisté',
      num: 'Numéro ou poste',
      hint: 'Seuls les chiffres sont autorisés',
      save: 'Sauvegarder',
      errInvalid: 'Le numéro n\'est pas valide.',
      errExists: 'Le numéro {num} est déjà ajouté',
      errRequired: 'Ce champs est requis',
      addSuccess: 'Le numéro a été ajouté à la liste noire',
      addFailed: 'Impossible d\'ajouter le numéro à la liste noire'
    },
    fwd: {
      title: 'Renvoi d\'appel',
      num: 'Numèro de renvoi d\'appel',
      save: 'Sauvegarder',
      hint: 'Seuls les chiffres, l\'asterisque (*) ou dièse (#) sont autorisés',
      errRequired: 'Un numéro de téléphone est requis',
      errInvalid: 'Le numéro n\'est pas valide. Seuls les chiffres, l\'asterisque (*) ou dièse (#) sont autorisés'
    },
    media: {
      title: 'Sélection Media périphérique',
      labelInput: 'Périphérique d\'entrée',
      labelOutput: 'Périphérique de sortie',
      labelRingDev: 'Périphérique de sonnerie',
      labelRingtone: 'Son d\'appel entrant',
      labelRingingVolume: 'Volume de sonnerie',
      ringBtnTooltip: 'Jouer le son d\'appel entrant sélectionné',
      enableRingDev: 'Activer le périphérique de sonnerie',
      testBtnTooltip: 'Jouer le sonner pour tester le périphérique sélectionné',
      notSupported: 'Votre navigateur ne supporte pas la sélection des périphériques. ' +
        'L\'option est supportée par les navigateurs Google Chrome, Microsoft Edge et Opera. ' +
        'Mozilla Firefox a cette option en mode experimental et peut être activer avec ' +
        'paramètre "media.setsinkid.enabled". Si voue avez besoin d\'aide, communiquez ' +
        'avec le Service technique.',
      ringingUpdateFail: 'Échec de la mise à jour de la sonnerie: {err}',
      ringtoneSaved: 'Son d\'appel entrant sauvegardé'
    },
    emergency: {
      title: 'Paramètres d\'appel urgent',
      profile: 'Profile d\'urgence Call-Back',
      location: 'L\'emplacement acheminée',
      default: 'Identification d\'urgence par default',
      noData: 'Il n\'y a pas des paramètres disponible. Veuillez demander votre Administrateur',
      permLimit: {
        title: 'Certains permissions sont désactivé',
        profRd: 'profiles lire',
        profWr: 'profiles ecrir',
        locRd: 'locations lire',
        locWr: 'locations ecrir'
      },
      callerName: 'Nom de l\'appelant',
      callerNum: 'Numéro de rappel',
      callerIDPrefix: 'Préfixe d\'identification de l\'appelant',
      callbackNum: 'Numéro de rappel',
      locName: 'Nom',
      address: 'Adresse'
    },
    clearlyaw: {
      title: "Télécharger l'application Clearly Anywhere",
      tooltip: {
        googlePlay: 'Trouver dans Google Play',
        appleStore: 'Télécharger dans App Store',
        appleApp: 'Télécharger l\'application MacOS Desktop',
        winApp: 'Télécharger l\'application Windows Desktop',
        qrcode: 'Configuration via QR code',
        help: 'En savoir plus sur Clearly Anywhere'
      },
      qrdlg: {
        title: 'Configuration via QR code',
        credInfo: 'Configuration manuelle',
        email: 'Courriel',
        passwd: 'Mot de passe',
        pwdText: 'Mot de passe d\'utilisateur d\'authentification',
        realm: 'Serveur/Domaine',
        reset: 'Réinitialiser',
        btnClose: 'Fermer',
        btnByEmail: 'Configuration par courriel'
      },
      credsPostOK: 'Courriel envoyé avec succès',
      credsPostFail: 'Échec de l\'envoi: ',
      credsResetOK: 'Le code QR a été réinitialisé avec succès',
      credsResetFail: 'Erreur lors de la réinitialisation du code QR: ',
      qrhelp: 'Scannez ce QR code avec l\'application Clearly Anywhere ' +
        'pour connecter votre compte',
      failed: 'Échoué à obtenir les données pour Clearly Anywhere QR Code'
    },
    toggle: {
      title: 'Destinations alternatives',
      notifySuccess: 'Destination pour "{name}" est mit à "{dest}"'
    },
    user: {
      title: 'Paramètres de votre utilisateur',
      updateOk: 'Les paramètres sont enregistrés',
      selectBox: 'Chousissez le compte d\'utilisateur',
      otp: {
        title: 'Les paramètres OTP (One-time password)',
        updateOk: 'Les paramètres OTP sont enregistrés',
        updating: 'Mise à jour...',
        enable: 'OTP activé (2FA)',
        method: 'Méthode OTP',
        sms: 'SMS',
        phoneNum: 'Numéro de téléphone',
        email: 'Courriel',
        emailAddr: 'Courriel OTP',
        qrcode: 'Authentificateur',
        qrcHelp: 'Scannez ce code QR avec votre authentificateur d\'application',
        errUpdate: 'La mis à jour de paramètres OTP a échoué',
        errPermissions: 'Vous n\'avez pas d\'access  pour changer les paramètres',
        errSMS: 'Le numéro de téléphone est invalid',
        errEmail: 'L\'adresse courriel est invalid'
      },
      lbl: {
        username: 'Nom d\'utilisateur',
        email: 'Courriel',
        pwdNew: 'Nouveau mot de passe',
        pwdConfirm: 'Confirmez le nouveau mot de passe'
      },
      btn: {
        update: 'Enregistrer',
        cancel: 'Annuler',
        save: 'Sauvegarder',
        otp: 'OTP'
      },
      err: {
        required: 'Ce champ est obligatoire',
        pwdMatch: 'Les mots de passe ne correspondent pas',
        update: 'La mis à jour de paramètres d\'utilisateur a échoué'
      }
    },
    clickToDial: {
      title: 'Paramètre du cliquer pour composer',
      labelDestination: 'Destination',
      destinationTypes: {
        softphoneShow: 'Afficher le clavier numérique',
        callPanelDial: 'Appeler via le tableau des appels',
        dialAfterOriginate: 'Appeler via mon appareile physique'
      },
      installCallHandler: 'Installer'
    },
    dids: {
      title: 'DID',
      table: {
        noData: 'Aucun DID disponible pour cet utilisateur',
        name: 'Nom',
        did: 'Numéro',
        destType: 'Type de destination',
        destName: 'Nom de la destination',
        smsCapable: 'SMS'
      },
      default: 'défaut'
    },
    screenPop: {
      title: "Paramètres fenêtre contextuelle d'appel",
      type: 'Type',
      typeList: {
        none: 'Aucun',
        url: 'URL'
      },
      trigger: 'Déclencheur',
      triggerList: {
        ringing: 'Sonnerie',
        answered: 'Réponse'
      },
      url: 'URL',
      save: 'Sauvegarder',
      help: 'Variables de template de l\'URL:',
      variable: {
        callerid_number: 'Numéro de l\'ID de l\'appelant',
        callerid_name: 'Nom de l\'ID de l\'appelant',
        extension: 'Numéro de l\'extension appelée',
        extension_name: 'Nom de l\'extension appelée',
        did: 'DID',
        wait_sec: 'Temps d\'attente en secondes'
      }
    },
    stunServers: {
      title: 'Serveurs STUN',
      label: 'Liste des serveurs STUN, séparés par des virgules',
      caption1: 'Exemple: stun:example.com, stuns:example.org:1234',
      caption2: 'Laissez vide pour utiliser le serveur STUN par defaut: stun:stun.l.google.com:19302',
      caption3: 'Nécessite de relancer le Call Panel pour prendre effet.',
      invalidFormat: 'Format invalide',
      save: 'Sauvegarder + Relancer'
    }
  },
  help: {
    notifications: {
      enable: "Activez ou désactivez les notifications qui incluent les notifications d'appels entrants et les notifications de message entrantes. Si vous avez autorisé les notifications dans votre navigateur, vous recevrez des notifications système vous permettant d'être averti même lorsque le panneau d'appels est réduit. Si ce n'est pas activé, vous aurez des notifications dans le panneau d'appel uniquement.",
      timeout: 'Délai en secondes pendant lequel la notification restera visible'
    },
    vm: {
      email: 'Une adresse courriel pour les message de la boîte vocale.',
      pager: 'Une adresse de téléavertisseur pour les notifications.',
      pin: 'NIP utilisé lors de la connexion sur la boîte vocale. Ne peut contenir que ' +
        'des chiffres.',
      attach: 'Configure l\'état d\'inclusion du message en pièce jointe par courriel',
      delvm: 'Supprimer le message vocal après notification.',
      playcid: 'Lire le CID avant de jouer la message.',
      envelope: 'Lire le date et le temps quand la message est créé.',
      archive: 'Si l\'enregistrement est archivé il est possible de retabli est remplacer ' +
        'les enregistrements existents',
      skipInstruct: 'Par défaut, lorsque quelqu\'un accède à votre messagerie vocale, le ' +
        'message d\'instructions est lu: "Veuillez laisser votre message après la ' +
        'tonalité, lorsque vous avez terminé de raccrocher ou appuyez sur la touche ' +
        'dièse". Cette option désactivera la lecture des instructions pour votre boîte vocale',
      transcript: 'Votre message vocal sera transcrit en texte. Vous pourrez lire vos messages vocaux sous forme de texte à partir de l\'interface Web ou de la notification par e-mail, si elle est activée.',
      translate: 'Si la transcription est activée, le texte transcrit sera traduit dans votre langue (français ou anglais). Vous pourrez lire vos messages vocaux sous forme de texte et traduits à partir de l\'interface Web ou de la notification par e-mail, si activé.',
      greeting: {
        name: 'L\'enregistrement audio contenant votre nom. C\'est ce l\'enregistrement ' +
          'qui sera entendu dans le répertoire téléphonique, ainsi que dans votre ' +
          'boîte vocale',
        busy: 'C\'est l\'enregistrement qui sera entendu dans votre boîte vocale lorsque ' +
          'vous rejetez un appel ou êtes en mode "Ne pas déranger"',
        unavail: 'C\'est l\'enregistrement qui sera entendu dans votre boîte vocale lorsque ' +
          'vous manquez un appel.',
        temp: 'C\'est l\'enregistrement qui sera entendu dans votre boîte vocale lorsque ' +
          'vous manquez un appel ou êtes deja au telephone. Remplace le message d\'acceuil si occupé et d\'indisponibilité lorsque activé.'
      },
      xfer: 'Cherche un destination disponible pour le transfert. Veuillez composer le nom ou ' +
        'le poste du destination et puis choisissez dans le liste.'
    },
    confr: {
      inv: 'Inviter à la conference un numéro. Entrer le numéro et appuyez le button "Inviter". ' +
        'Le système va envoyer un appel ver le numéro et l\'appel va rejoindre la conference. ' +
        'No NIP nécessite pour se connecter quand invité.'
    },
    bargein: {
      monitor: 'Permet à la personne qui fait l\'intervention de venir sur l\'appel et d\'écouter ' +
        'les deux parties de l\'appel mais ne peux parler et aucune des partie sera informé ' +
        'par une tonalité',
      full: 'Permet à l\'usager qui fait l\'intervention de venir sur l\'appel et d\'écouter les deux direction ' +
        'de l\'appel. L\'usagé sera mis en sourdine et pourra la retirer pour prendre par à l\'appel.' +
        'Une tonalité sera entendu par les deux parties',
      whisper: 'Permet à la personne qui fait l\'intervention de venir sur l\'appel et d\'écouter les deux coté de l\'appel mais ' +
        'seulement parler à une personne particulière. Seulement la direction d\'appel selectioné percevera une tonalité ' +
        'les informant de l\'intervention en cour'
    },
    pcs: {
      countSay: 'Annoncer le nombre courant de participants lorsque quelqu\'un rejoint la conférence.',
      moh: 'Lecture d\'une musique d\'attente lorsqu\'il n\'y a qu\'un seul participant.',
      waitAdmin: 'Attendre l\'arrivée de l\'administrateur (hôte) de la conférence pour débuter la ' +
        'conférence. Si "Attente musicale" est activée, une musique d\'attente sera jouée en attendant ' +
        'l\'administrateur.',
      joinSay: 'Annoncer lorsqu\'un participant rejoint ou quitte la conférence.',
      openMenu: 'Écouter les options de la conférence à l\'appui de la touche "*".',
      listenOnly: 'Les participants connectés avec le NIP Utilisateur ne peuvent pas parler.'
    },
    callfwd: 'Renvoi tout les appels ver le numéro donné.',
    dnd:
      'Activer ou désactiver le mode NPD côté serveur. En mode NPD, tous les appels seront dirigés vers la ' +
      'destination occupée de l\'utilisateur qui est par défaut sa boîte vocale.',
    callwait:
      'Si vous êtes en communication active et qu\'un appel supplémentaire arrive, cet appel apparaîtra et ' +
      'vous aurez la possibilité de répondre à l\'appel pendant que l\'appel en cours est mis en attente.',
    icomDesk:
      'Si un appel intercom arrive sur votre téléphone de bureau avec cette option activée, le téléphone ' +
      'répondra automatiquement. Si vous êtes en communication active lorsque l\'interphone arrive, l\'appel ' +
      'sera traité comme une sonnerie entrante au lieu d\'une réponse automatique sur la plupart des téléphones de bureau SIP.',
    icomCallpanel:
      'Si un appel intercom parvient à votre CallPanel Softphone avec cette option activée, le CallPanel Softphone ' +
      'répondra automatiquement. Si vous êtes en communication active lorsque l\'interphone arrive, l\'appel sera ' +
      'traité comme une sonnerie entrante au lieu d\'une réponse automatique.',
    icomAnywhere:
      'Si un appel intercom parvient à votre Clearly Anywhere Softphone avec cette option activée, Clearly Anywhere ' +
      'Softphone répondra automatiquement. Si vous êtes en communication active lorsque l\'interphone arrive, l\'appel ' +
      'sera traité comme une sonnerie entrante au lieu d\'une réponse automatique.',
    media: 'Périphérique media entrants ou sortants pour les appels, enregistrements etc.',
    clearlyaw: 'Depuis cette page vous pouvez vous connecter à Clearly Anywhere. Avec ' +
      'Clearly Anywhere, les utilisateurs peuvent communiquer sans frais et composer ' +
      'directement le poste d\'un autre utilisateur. Pour certains utilisateurs, ceci ' +
      'remplace complètement le téléphone de bureau',
    intercom: 'Si activé, les appels entrants ver un téléphone seront répondus automatiquement.',
    showMissedCalls: 'Si activé, affiche le nombre d\'appels manqués dans le softphone et la barre d\'outils.',
    mediaRingDev: 'Si la périphérique est mit elle va étre utilisée pour sonner les appels entrants.',
    followme: {
      enable: 'Activer la fonctionnalité "Suivez-moi"',
      confirm: 'Activer cette option si vous appelez les numéros externes qui ont besoin de ' +
        'confirmation - par exemple , un téléphone mobile peut rediriger l\'appel à sa ' +
        'messagerie vocale ce qui va prendre l\'appel. L\'activation de cette option ' +
        'nécessite d\'appuyer sur le 1 sur le téléphone avant que l\'appel soit ' +
        'redirigé.',
      markanswered: 'Les appels doivent-ils indiquer une réponse ailleurs lorsqu\'un utilisateur répond.',
      prefix: 'Veuillez mettre un text court pour le préfix de CID',
      toutFirst: 'Vous pouvez choisir une condition temporelle pour activer la ' +
        'fonctionnalité "Suivez-moi"',
      toutAll: 'Vous pouvez établir un délai maximum pour faire sonner votre ' +
        '"Suivez-moi"',
      num: 'List des poste ou les numéros à faires sonner.',
      cid: 'Cette option ne s\'applique qu\'aux numéros externes "suivez-moi". ' +
        'S\'il s\'agit d\'un appel entrant d\'un numéro externe et que le ' +
        'suivi est défini sur un numéro externe (comme un téléphone portable), ' +
        'vous pouvez définir ici l\'afficheur de l\'appelant que vous verrez ' +
        'sur votre appareil de destination externe.',
      externCIDName: 'Lorsque vous utilisez un afficheur personnalisé, vous pouvez choisir quel identifiant va apparaitre. Ce champs permet de définir le nom de l\'afficheur.',
      externCIDNum: 'Lorsque vous utilisez un afficheur personnalisé, vous pouvez choisir quel identifiant va apparaitre. Ce champs permet de définir le numéro de l\'afficheur.',
      timeCond: 'Vous pouvez choisir une condition temporelle pour vos numéros "suivez-moi".' +
        'Si cet paramétrer est choisi les appels "suivez-moi" seront rediriges seulement ' +
        'quand la conditions temporelle est vraie. Les conditions temporelle sont crées ' +
        'par administrateur.',
      strategies: "<b>Sonner tous les postes</b>: tous les postes sonnent en même temps jusqu'à ce qu'un poste décroche. Si personne ne répond avant l'expiration de la durée de sonnerie, l'appel est redirigé vers la 'Destination si échec'.<br><b>Sonner les postes séquentiellement</b>: Les postes sonnent tour à tour, en appliquant la durée de sonnerie à chacun des postes. Si aucun des postes ne répond, l'appel est redirigé vers la 'Destination si échec'. <br> <b>Sonner les postes séquentiellement avec mémoire</b>: Fait sonner les postes séquentiellement en conservant les postes précédents dans le processus de sonnerie jusqu'à ce que l'appel soit répondu."
    },
    queues: {
      pauseCause: 'Veuillez choisir la raison de mettre/retirer l\'agent en pause. ' +
        'Cette raison sera disponible dans les statistiques.'
    },
    callRec: 'Téléchargez l\'enregistrement. Si le téléchargement annulé il est perdu.',
    emergency: {
      profile: 'Le profil de rappel d\'urgence fournit le nom de la compagnie ' +
        'et le numéro de rappel pendent l\'appel urgent',
      location: 'L\'emplacement d\'envoi de votre appareil'
    },
    toggle: 'Une destinations alternative contient deux destinations et pointe vers ' +
      'l\'une ou vers l\'autre. Vous pouvez changer la destination cible à tout moment ' +
      'en appelant "*44*ID" ou depuis cette page. Vous trouverez l\'ID depuis dans cette grille.',
    userAccSelect: 'Vous avez les droits d\'accès au compte des plusiers utilisateurs ' +
      'et vous pouvez changer leurs options si vous avez les permissions. ',
    blacklist: 'Gérer les numéros ajoutés à la liste noire.',
    clickToDial: 'Comment procéder les requêtes click-to-dial.'
  },
  perms: {
    nochange: 'Pas des permissions qui permettent le changement',
    readOnly: 'Lecture seulement',
    noPermission: 'Aucune permission de lecture ou écriture'
  }
}
